@for (filter of globalFilters(); track filter.fieldName) {
  @if (!(disabledGlobalFilters() | contains: filter.fieldName)) {
    <procure-search-filter
      isGlobal
      [filter]="filter"
    />
  }
}
@if (activeTab() && activeTab()?.entityType !== "all") {
  @for (filter of activeTab()?.filters; track filter.fieldName) {
    <procure-search-filter [filter]="filter" />
  }
  <search-facets />
}
